/* eslint-disable react/prop-types */
import { Component } from "react";
// import PropTypes from "prop-types";
import SessionStore from "../stores/SessionStore";


class Admin extends Component {
  constructor() {
    super();
    this.state = {
      admin: false,
    };

    this.setIsAdmin = this.setIsAdmin.bind(this);
  }

  componentDidMount() {
    SessionStore.on("change", this.setIsAdmin);
    this.setIsAdmin();
  }

  componentWillUnmount() {
    SessionStore.removeListener("change", this.setIsAdmin);
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) {
      return;
    }

    this.setIsAdmin();
  }

  setIsAdmin() {
    if (this.props.organizationID !== undefined) {
      this.setState({
        admin: SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(this.props.organizationID),
      });
    } else {
      this.setState({
        admin: SessionStore.isAdmin(),
      });
    }
  }

  render() {
    if (this.state.admin) {
      return(this.props.children);
    }

    return(null);
  }
}

// CARE (DEM 2021-04-23)
// Using propTypes caused following issue when listing service-profiles (system admin user)
// "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate..."

// Admin.propTypes = {
//   organizationID: PropTypes.any,
//   children: PropTypes.any.isRequired,
// }

// Admin.defaultProps = {
//   organizationID: 0
// }

export default Admin;
